import axiosHttpRequest from "../axios";

async function getWagonMaintenanceList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveWagonMaintenanceLastComposition(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function saveWagonMaintenanceCurrentComposition(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function validateWagonMaintenanceByRakeName(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getLatestJobDetailsByRakeNameList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getScheduleMaintenanceList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveScheduleMaintenance(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSpareScheduleMaintenanceList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveSpareScheduleMaintenance(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function getBPCNo(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  return serviceData;
}

export default {
  getWagonMaintenanceList,
  saveWagonMaintenanceLastComposition,
  saveWagonMaintenanceCurrentComposition,
  validateWagonMaintenanceByRakeName,
  getLatestJobDetailsByRakeNameList,
  getScheduleMaintenanceList,
  saveScheduleMaintenance,
  getSpareScheduleMaintenanceList,
  saveSpareScheduleMaintenance,
  getBPCNo,
};
